import React from "react";
import ImproveYield from "../../assets/images/benefits/improved-crop-quality.svg";
import MigrateNow from "../../assets/images/benefits/migrate-pay-later.svg";
import BuyNow from "../../assets/images/benefits/pay-later.svg";

import USPSection2Cards from "../../components/USPSection2/USPSection2Cards";
import { Row, Col } from "react-bootstrap";

const BeekeeperBenefits = () => {
  const benefits = [
    {
      title: "Improve yield",
      bodycopy:
        "Improving yield benefits beekeepers by increasing honey production, hive health, and providing valuable pollination services for higher agricultural productivity.        ",
      image: ImproveYield,
    },
 
    {
      title: "Migrate now & pay later",
      bodycopy:
        '"Migrate now & pay later" benefits beekeepers by allowing them to move their hives to better forage areas without upfront costs, improving productivity while deferring financial investment.',
      image: MigrateNow,
    },
    {
        title: "Buy inputs now & pay later",
        bodycopy:
        '"Buy now & pay later" benefits beekeepers by allowing them to purchase necessary supplies and equipment immediately while deferring payment, easing cash flow management.',
        image: BuyNow,
      },
  ];
  return (
    <>
      {" "}
      <Row>
        {benefits.map((e,index) => {
          return (
            <Col md={4} key={index}>
              <USPSection2Cards
                cardtitle={e.title}
                src={e.image}
                cardBodycopy={e.bodycopy}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default BeekeeperBenefits;
